




































































































































































































































































































































































import Vue from 'vue'
import {
  Parameter,
  GetParameter,
  PatchParameter,
  DeleteParameter,
  StatusParameter,
  GetListOfStatusParameter,
} from '@/api/cems'
import { Find as FindDevice } from '@/api/device'
import { Device } from '@/types/device'

export default Vue.extend({
  name: 'FormEditParameter',
  data() {
    return {
      listStatusParameter: [] as StatusParameter[],
      parameterUid: '',
      stackUid: '',
      parameter: { tag: {} } as Parameter,
      activeParameter: { tag: {} } as Parameter,
      devices: [] as Device[],
    }
  },
  methods: {
    async getListStatusParameter() {
      this.listStatusParameter = await GetListOfStatusParameter()
    },
    async getParameter() {
      this.parameter = await GetParameter(this.parameterUid)
    },
    async getActiveParameter() {
      if (this._isBeingDestroyed) {
        return
      }
      this.activeParameter = await GetParameter(this.parameterUid)

      setTimeout(async () => {
        try {
          await this.getActiveParameter()
        } catch {
          //
        }
      }, 1000)
    },

    async patchParameter() {
      await PatchParameter(this.parameterUid, this.parameter)
    },

    async deleteParameter() {
      await DeleteParameter(this.parameterUid)
      this.$router.replace(`/cems/setting/chimney/${this.stackUid}/parameter`)
    },

    async findDevices() {
      this.devices = await FindDevice()
    },

    formatValue(par: Parameter): string {
      if (typeof par.value == 'number') {
        return par.value.toFixed(par.precision)
      }

      return par.value
    },
  },

  async created() {
    this.stackUid = this.$route.params.stackUID
    this.parameterUid = this.$route.params.parameterUID
    await this.getListStatusParameter()
    await this.findDevices()
    await this.getParameter()
    await this.getActiveParameter()
  },
})
